<template>
  <div>
    <span :class="claseError">{{titulo}}</span>
    <span v-if="obligatorio" class="font-weight-bold ml-1" :class="claseError">*</span>
    <IconoInformacion :sInformacion="sInformacion"/>
     <v-tooltip v-if="sTooltip!=''" top>
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :ref="`form`"
          :hide-details="bOcultarDetalle"
          v-model="valor"
          :id="oAtributos?.id"
          single-line
          outlined
          clearable
          dense
          :disabled="bEditable"
          :error="esError"
          :placeholder="sPlaceHolder"
          :rules="aReglas"
          :maxlength="nMaxLength"
          :counter="bMostrarCounter"
          v-bind="attrs"
          v-on="on"
        />
      </template>
      <span>{{sTooltip}}</span>
    </v-tooltip>
    <v-text-field
      v-else
      :ref="`form`"
      :hide-details="bOcultarDetalle"
      class=""
      v-model="valor"
      :id="oAtributos?.id+'texto2'"
      single-line
      outlined
      clearable
      dense
      :disabled="bEditable"
      :error="esError"
      :placeholder="sPlaceHolder"
      :rules="aReglas"
      :counter="bMostrarCounter"
      :maxlength="nMaxLength"
      >
    </v-text-field>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FormMixin from '@/mixins/formularioMixin.js'
import IconoInformacion from '@/components/Form/Componentes/subComponentes/IconoInformacion.vue'

export default {
  name: 'FormTexto',
  mixins: [FormMixin],
  components: {
    IconoInformacion,
  },
  props: {
    condicion:{
      type: String,
      default: ''
    },
    oAtributos:{
      type:Object,
      default:()=>{}
    }
  },
  data() {
    return {
      valor   : this.value,
      esError : false,
      aReglas : [v => !!v],
      bEditable : (this.editable == "0") ? true : false,
      nMaxLength: 524288,
      bMostrarCounter: false,
      bOcultarDetalle: true,
      bPrueba: false,
      oRef: this.$refs['form'],
      // sIniValue : null,
      // sValorIniv:''
    }
  },
  mounted(){
    this.nMaxLength = parseInt(this.onValidarProps('maxlength', '524288', this.condicion))
    if(this.nMaxLength) {
      this.bMostrarCounter = true
      this.bOcultarDetalle= false
      this.aReglas.push((v) => v && v.length <= this.nMaxLength || `Max ${this.nMaxLength} characters`);
    }
    // this.sIniValue = this.onValidarProps('iniValue', '', this.condicion)
    // if(this.sIniValue){
    //   this.aReglas.push(this.validarURL)
    // }
    this.onCrearReglas()
  },
  methods: {
    validarURL(v){
      if (!v || v.startsWith(this.sIniValue)) {
        return true;
      }else{
        return `Debe empezar con '${this.sIniValue}'`;
      }
    }
  },
  computed: {
    ...mapGetters(['getoFormError'])
  },
  watch: {
    value(){
      this.valor=this.value;
    },
    onError() {
      this.error = this.onError
    }
  },
  
}
</script>

<style scoped>


</style>